import styles from './RowCheckbox.module.less';

type RowCheckboxProps = {
  isSelected: boolean,
  isDisabled?: boolean,
};

const RowCheckbox = ({ isSelected, isDisabled }: RowCheckboxProps) =>
  <span className={styles.checkbox}>
    <input type="checkbox" checked={isSelected} disabled={isDisabled} />
  </span>;

export default RowCheckbox;
